(() => {
  const instances = new WeakMap();

  function setup(root) {
    if (instances.has(root)) return;
    const controller = new AbortController();
    const options = { signal: controller.signal };
    const desktop = window.matchMedia('(min-width: 1280px)');
    const drawer = root.querySelector('header-drawer');
    const drawerDetails = drawer?.querySelector('details');
    const drawerSummary = drawerDetails?.querySelector('summary');
    let drawerScrollPosition = null;

    function closeMenus(except) {
      root.querySelectorAll('header-menu').forEach((menu) => {
        if (menu.querySelector('details') !== except) menu.close();
      });
    }

    function updateStickyState() {
      root.preventHide = Boolean(root.querySelector('header-menu details[open]')) || Boolean(drawerDetails?.open);
      root.currentScrollTop = window.scrollY;
    }

    function syncDrawerViewport() {
      if (desktop.matches || !drawerDetails?.open) return;
      if (drawerScrollPosition && (window.scrollY !== drawerScrollPosition.y || window.scrollX !== drawerScrollPosition.x)) {
        window.scrollTo({ top: drawerScrollPosition.y, left: drawerScrollPosition.x, behavior: 'instant' });
      }
      const section = root.closest('.section-header');
      if (!section) return;
      const bottom = Math.max(0, Math.round(section.getBoundingClientRect().bottom));
      document.documentElement.style.setProperty('--header-bottom-position', `${bottom}px`);
      document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
    }

    root.addEventListener('click', (event) => {
      if (desktop.matches || !drawerDetails || event.target.closest('summary') !== drawerSummary || drawerDetails.open) return;
      drawerScrollPosition = { x: window.scrollX, y: window.scrollY };
    }, { capture: true, signal: controller.signal });

    root.addEventListener('click', (event) => {
      const link = event.target.closest('[data-idw-loyalty-link]');
      if (!link || !drawer?.contains(link) || !drawerDetails?.open || typeof drawer.closeMenuDrawer !== 'function') return;
      drawerScrollPosition = null;
      drawer.closeMenuDrawer(event, drawerSummary);
      drawerSummary?.setAttribute('aria-expanded', 'false');
    }, { capture: true, signal: controller.signal });

    root.addEventListener('toggle', (event) => {
      if (!(event.target instanceof HTMLDetailsElement)) return;
      if (event.target === drawerDetails) {
        if (drawerDetails.open && !desktop.matches) {
          drawerScrollPosition ||= { x: window.scrollX, y: window.scrollY };
          syncDrawerViewport();
        } else {
          drawerScrollPosition = null;
        }
      } else if (event.target.closest('header-menu')) {
        if (event.target.open) closeMenus(event.target);
      } else {
        return;
      }
      setTimeout(() => {
        updateStickyState();
        syncDrawerViewport();
      }, 0);
    }, { capture: true, signal: controller.signal });

    window.addEventListener('scroll', syncDrawerViewport, { passive: true, signal: controller.signal });
    window.addEventListener('resize', syncDrawerViewport, options);

    document.addEventListener('pointerdown', (event) => {
      if (!event.target.closest('.idw-primary-nav, .idw-service-nav')) closeMenus();
    }, options);

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      const search = event.target.closest('predictive-search');
      if (search?.isOpen) {
        search.close();
        event.preventDefault();
        event.stopPropagation();
      }
    }, options);

    function changeLayout() {
      closeMenus();
      if (desktop.matches && drawerDetails?.open) {
        drawerScrollPosition = null;
        const focusTarget = root.querySelector('.header__heading-link') || drawerSummary;
        drawer.closeMenuDrawer(new Event('change'), focusTarget);
        drawerSummary.setAttribute('aria-expanded', 'false');
      }
    }

    desktop.addEventListener('change', changeLayout, options);
    instances.set(root, controller);
  }

  function scan(container) {
    container.querySelectorAll('.idw-navigation').forEach(setup);
  }

  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll('.idw-navigation').forEach((root) => {
      instances.get(root)?.abort();
      instances.delete(root);
    });
  });
})();


